import React,{ Fragment } from "react";

const NoMatch = () => {
    return ( <Fragment>
        <p>Taka strona nie istnieje</p>
    </Fragment> );
}
 
export default NoMatch;